<div class="loading-overlay">
  <div class="loading-overlay__container">
    <p class="loading-overlay__label" [innerText]="loadingLabel"></p>
    <div class="loading-overlay__progress">
      <div class="loading-overlay__progress--indeterminate"></div>
    </div>
  </div>
</div>
